// extracted by mini-css-extract-plugin
export var grid = "ContactGrid-module--grid--5mWF9";
export var pEmail = "ContactGrid-module--pEmail--MAmxI";
export var pName = "ContactGrid-module--pName--YFR0T";
export var pPhone = "ContactGrid-module--pPhone--Y1cZb";
export var pTitle = "ContactGrid-module--pTitle--iGo0L";
export var separator = "ContactGrid-module--separator--6Zws7";
export var title = "ContactGrid-module--title--Q0SMW";
export var wrapper = "ContactGrid-module--wrapper--zyuO0";